'use client';
import React from "react";
import Navbar from "@/components/Layout/Header/Navbar";
import {usePathname} from 'next/navigation';

export default function NavbarComponent({catalogData}) {
    const pathname = usePathname();

    const isShopSection = pathname.startsWith('/shop/category');

    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    return (
        <>
            <Navbar catalogData={catalogData}/>
        </>
    )
}